import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { SolicitudDetallePage } from "@/features/solicitud-detalle/components/SolicitudDetallePage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";

/**
 * Ruta `/solicitudes/$id` · detalle completo · loader precarga la
 * solicitud para cero parpadeo. Los polling/queries auxiliares (chat,
 * polizas) se activan según estado dentro del componente.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: SolicitudDetallePage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
